/**
 * Tipos de encerramento que registram acordo fechado. O legado `'ACORDO'` fica de fora de
 * propósito: `RESUMO_POR_TIPO` não tem essa chave, e quem precisa dele o trata à parte.
 */
export const TIPOS_ENCERRAMENTO_COM_ACORDO: ReadonlySet<string> = new Set([
  'ACORDO_MANUAL',
  'ACORDO_IA',
]);
